export default function ProcessSection() {
  const steps = [
    {
      number: '01',
      title: 'Beratung & Bedarf klären',
      description:
        'Sie melden sich telefonisch, per E-Mail oder über das Kontaktformular. Gemeinsam klären wir, welche Unterstützung im Alltag gebraucht wird und wie wir sinnvoll entlasten können.',
      icon: 'ri-chat-smile-3-line'
    },
    {
      number: '02',
      title: 'Passende Unterstützung planen',
      description:
        'Wir besprechen den konkreten Bedarf, mögliche Einsätze und passende Leistungen wie Wohnungsreinigung, Einkaufen, Kochen oder Begleitung zu Terminen.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '03',
      title: 'Unterstützung startet',
      description:
        'Nach der Abstimmung startet die vereinbarte Unterstützung. Zuverlässig, freundlich und passend zur persönlichen Situation.',
      icon: 'ri-home-heart-line'
    },
    {
      number: '04',
      title: 'Laufend abgestimmt',
      description:
        'Wir bleiben Ihr Ansprechpartner, passen Leistungen bei Bedarf an und sorgen dafür, dass die Unterstützung langfristig passend bleibt.',
      icon: 'ri-heart-3-line'
    }
  ];

  const faqs = [
    {
      question: 'Was bedeutet Alltagshilfe nach §45b SGB XI?',
      answer:
        'Alltagshilfe unterstützt bei Aufgaben wie Wohnungsreinigung, Einkaufen, Begleitungen, Gesellschaft leisten oder Alltagsorganisation. Sie richtet sich an Personen mit Pflegegrad und entlastet im täglichen Leben.'
    },
    {
      question: 'Übernimmt die Pflegekasse die Kosten?',
      answer: (
        <>
          Je nach persönlicher Situation können Leistungen über den Entlastungsbetrag unterstützt werden. Ob und in welchem Umfang Kosten übernommen werden, klären wir individuell. Für eine unverbindliche Einschätzung schreiben Sie uns gerne an{' '}
          <a href="mailto:info@alltagsstern.com" className="font-medium text-[#027FDB] hover:text-[#027FDB] underline underline-offset-4">
            info@alltagsstern.com
          </a>
          .
        </>
      )
    },
    {
      question: 'Welche Leistungen bieten Sie konkret an?',
      answer:
        'Zu unseren Leistungen gehören Wohnungsreinigung, Wäschepflege, Fensterreinigung, Einkaufen, Termine begleiten, Botengänge, Kochen, Mobilitätshilfe, Gesellschaft leisten und Alltagsorganisation.'
    },
    {
      question: 'In welchen Berliner Bezirken sind Sie tätig?',
      answer:
        'Wir sind berlinweit im Einsatz. Die genaue Verfügbarkeit besprechen wir individuell bei Ihrer Anfrage.'
    }
  ];

  return (
    <section
      id="process-section"
      className="relative overflow-hidden py-20 md:py-24 bg-white text-[#0F172A] scroll-mt-28 md:scroll-mt-32"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-12 right-[-5rem] h-56 w-56 rounded-full bg-[#027FDB]/12 blur-3xl" />
        <div className="absolute bottom-10 left-[-4rem] h-56 w-56 rounded-full bg-[#027FDB]/10 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 md:gap-6">
          <div className="max-w-2xl">
            <p className="text-[11px] md:text-xs tracking-[0.18em] uppercase mb-4 text-[#027FDB] font-semibold">
              So läuft die Unterstützung ab
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-[2.6rem] font-semibold mb-4 leading-tight text-[#0F172A]">
              In 4 klaren Schritten zur passenden Alltagshilfe
            </h2>
            <p className="text-base md:text-lg leading-relaxed text-[#334155]">
              Transparent und unkompliziert: Von der ersten Anfrage bis zur passenden Unterstützung begleiten wir Sie klar, zuverlässig und verständlich.
            </p>
          </div>

          <div className="hidden lg:flex flex-col items-end gap-2 rounded-[1.4rem] border border-[#027FDB]/10 bg-[#EAF6FF] px-5 py-4 text-right shadow-[0_8px_24px_rgba(2,127,219,0.08)]">
            <div className="flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-[#027FDB] font-semibold">
              <i className="ri-route-line text-base text-[#027FDB]" />
              <span>Ablauf</span>
            </div>
            <span className="text-xs tracking-[0.18em] uppercase text-[#027FDB]/80">
              Einfach erklärt
            </span>
          </div>
        </div>

        <div className="relative mt-12 md:mt-14">
          <div className="hidden lg:block absolute top-[2.8rem] left-[6%] right-[6%] h-px bg-[linear-gradient(90deg,rgba(2,127,219,0.0),rgba(2,127,219,0.18),rgba(2,127,219,0.35),rgba(2,127,219,0.0))]" />

          <div className="relative z-10 grid gap-5 md:gap-6 md:grid-cols-2 lg:grid-cols-4">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className="group flex flex-col items-stretch text-left rounded-[1.5rem] border border-[#027FDB]/10 bg-[linear-gradient(135deg,rgba(255,255,255,0.98),rgba(234,246,255,0.94),rgba(224,242,254,0.82))] p-5 md:p-6 shadow-[0_14px_32px_rgba(15,23,42,0.05)] transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start gap-4 mb-5">
                  <div className="relative">
                    <div className="w-12 h-12 rounded-2xl bg-[#027FDB] border border-[#027FDB]/10 flex items-center justify-center shadow-[0_12px_30px_rgba(2,127,219,0.18)]">
                      <i className={`${step.icon} text-lg text-white`} />
                    </div>
                    <span className="absolute -bottom-4 left-1/2 -translate-x-1/2 inline-flex items-center justify-center w-8 h-8 rounded-full bg-white border border-[#027FDB]/10 text-[0.65rem] font-semibold tracking-[0.18em] uppercase text-[#027FDB] shadow-[0_8px_18px_rgba(2,127,219,0.08)]">
                      {step.number}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-[0.95rem] tracking-[0.08em] uppercase text-[#0F172A] leading-snug max-w-[13rem] font-semibold">
                    {step.title}
                  </h3>
                </div>

                <p className="mt-4 text-sm md:text-[0.95rem] leading-relaxed text-[#475569]">
                  {step.description}
                </p>

                {index < steps.length - 1 && (
                  <div className="lg:hidden mt-6 ml-5 w-px h-10 bg-[linear-gradient(180deg,rgba(2,127,219,0.18),rgba(2,127,219,0.32))]" />
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 md:mt-16 rounded-[2rem] border border-[#027FDB]/10 bg-[linear-gradient(135deg,rgba(255,255,255,0.98),rgba(234,246,255,0.94),rgba(224,242,254,0.82))] p-5 md:p-8 shadow-[0_18px_50px_rgba(15,23,42,0.06)]">
          <div className="max-w-2xl mb-6 md:mb-8">
            <p className="text-[11px] md:text-xs tracking-[0.18em] uppercase mb-3 text-[#027FDB] font-semibold">
              Häufige Fragen
            </p>
            <h3 className="text-2xl md:text-3xl font-semibold leading-tight text-[#0F172A]">
              Wichtige Fragen zur Alltagshilfe in Berlin
            </h3>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-[#475569]">
              Die wichtigsten Fragen zu Leistungen, Kosten und Ablauf auf einen Blick.
            </p>
          </div>

          <div className="grid gap-4 md:gap-5 md:grid-cols-2 items-stretch">
            {faqs.map((faq) => (
              <div
                key={faq.question}
                className="rounded-[1.5rem] border border-[#027FDB]/10 bg-white p-5 md:p-6 shadow-[0_10px_28px_rgba(15,23,42,0.05)] h-full"
              >
                <div className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#EAF6FF] text-[#027FDB] border border-[#027FDB]/10">
                    <i className="ri-question-line text-lg" />
                  </span>
                  <div>
                    <h4 className="text-base md:text-lg font-semibold leading-snug text-[#0F172A]">
                      {faq.question}
                    </h4>
                    <p className="mt-3 text-sm md:text-[0.95rem] leading-relaxed text-[#475569]">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
